import type React from 'react';

import type { Company } from '@xing-com/crate-common-graphql-types';

import { CompanyCardsSkeletonLoggedout } from '../../components/skeleton';
import { useMostVisitedCompanies } from '../../hooks/use-most-visited-companies';
import { ROUTES } from '../../routes/routes';
import type { SetErrorType } from '../../types/common';
import { CompaniesRow } from './companies-row';

const LIMIT = 5;

const MostVisitedCompaniesModule: React.FC<SetErrorType> = ({ setError }) => {
  const { data, loading, error } = useMostVisitedCompanies({
    limit: LIMIT,
  });

  if (loading) return <CompanyCardsSkeletonLoggedout />;

  if (error) setError(!!error);

  const { collection } = data?.mostVisitedCompanies ?? {};

  return (
    <CompaniesRow
      title="CP_MOST_VISITED_COMPANIES_TITLE"
      showAllLink={ROUTES.mostVisitedCompanies}
      totalCaption="CP_MOST_VISITED_COMPANIES_CAPTION"
      companies={collection?.map((item) => item?.company as Company) ?? []}
    />
  );
};

export { MostVisitedCompaniesModule };
